import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import type { Experience } from '@/features/experience-shell/types'
import {
	type HttpUpdateExperienceVettingCriteriaItineraryCoveryImageOptions,
	httpUpdateExperienceVettingCriteriaItineraryCoveryImage
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateExperienceVettingCriteriaItineraryCoveryImage = (
	{
		experienceId,
		itineraryId
	}: { experienceId: number; itineraryId: number },
	options?: UseMutationOptions<
		Experience,
		unknown,
		HttpUpdateExperienceVettingCriteriaItineraryCoveryImageOptions['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpUpdateExperienceVettingCriteriaItineraryCoveryImage({
				urlParams: { experienceId, itineraryId },
				payload,
				params: {
					responseType: 'extended'
				}
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE_VETTING, experienceId] },
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
